import React, { useEffect } from "react"
import { css } from "@emotion/react"
import { Link, useLocation } from "react-router-dom"
import { Box, Button, Icon, Modal, usePrevious } from "@ncs/web-legos"
import { Logo } from "./Logo"
import { SiteNavigationEcomm } from "./SiteNavigationEcomm/SiteNavigationEcomm"
import { Divider } from "@material-ui/core"
import BottomFooter from "./site-footer/BottomFooter"
import { SocialMedia } from "./site-footer/SocialMedia"
import ContactUs from "./site-footer/ContactUs"

export interface MobileNavModalProps {
	isOpen: boolean
	onClose: () => void
}

export const MobileNavModalEcomm: React.FC<MobileNavModalProps> = React.memo(
	({ isOpen, onClose }) => {
		const location = useLocation()

		const prevLocation = usePrevious(location)
		useEffect(() => {
			// Close the nav modal if you click a link.
			if (location.key !== prevLocation.key) {
				onClose()
			}
		}, [onClose, location, prevLocation])

		return (
			<Modal isOpen={isOpen} onClose={onClose} fullScreen showCloseButton={false}>
				<Box css={modalContainerStyle}>
					<div>
						<Button
							onClick={onClose}
							css={css`
								margin-right: 12px;
							`}
						>
							<Icon icon="bars" fontSize={1.7} />
						</Button>

						<Link to="/">
							<Logo height={1.5} />
						</Link>
					</div>

					<SiteNavigationEcomm />

					<Box css={bottomFooterStyleLight}>
						<Divider />
						<ContactUs variant="mobile" />
						<SocialMedia isLight />
						<BottomFooter isLight />
					</Box>
				</Box>
			</Modal>
		)
	}
)

const modalContainerStyle = css`
	position: absolute;
	top: 20px;
	width: calc(100% - 1rem);
	display: grid;
	grid-template-columns: 1fr;
	grid-template-rows: auto 1fr auto;
	max-height: 100%;
	height: calc(100% - 3rem);
	box-sizing: border-box;
`

const bottomFooterStyleLight = css`
	display: flex;
	gap: 1rem;
	flex-direction: column;
	margin-right: 2rem;
`
